import React, { useState, useEffect, useCallback, useRef } from "react";
import { waitinglist } from "../../_Shared/Scripts/Endpoints";
import SuccessAnimation from "../../_Shared/Scripts/SuccessAnimation";

const PmcNotificationListForm = ({ lang, onSuccess, pmcId, onSubmit }) => {
  const [pending, setPending] = useState(false);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState(false);
  const [success, setSuccess] = useState(false);
  const timeoutRef = useRef(null);

  const validateEmail = useCallback((value) => {
    if (!value) return "Email is required.";
    const emailRegex = /^\S+@\S+\.\S+$/;
    return emailRegex.test(value) ? "" : "Enter a valid email address.";
  }, []);

  const resetForm = useCallback(() => {
    setEmail("");
    setSuccess(false);
    setErrors({});
    setTouched(false);
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setTouched(true);
    const emailError = validateEmail(email);
    if (emailError) return setErrors({ email: emailError });

    try {
      setPending(true);
      const response = await waitinglist.registerForNotifications({
        pmcId,
        email,
      });

      if (response.status === 201) {
        setSuccess(true);
        onSubmit();
        timeoutRef.current = setTimeout(() => {
          onSuccess();
          resetForm();
        }, 1400);
      }
    } catch (error) {
      setErrors({ common: "Unable to subscribe. Please try again!" });
    } finally {
      setPending(false);
    }
  }, [email, onSuccess, resetForm, validateEmail]);

  const handleEmailChange = useCallback((e) => {
    const value = e.target.value;
    setEmail(value);
    if (touched) {
      setErrors(prev => ({ ...prev, email: validateEmail(value) }));
    }
  }, [touched, validateEmail]);

  const handleBlur = useCallback(() => {
    setTouched(true);
    setErrors(prev => ({ ...prev, email: validateEmail(email) }));
  }, [email, validateEmail]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {!success ? (
        <form 
          className="pmc-notificaitonlist-form"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="input-container">
            <label htmlFor="email-input" className="email-form__label">
              Email
            </label>
            <input
              id="email-input"
              type="email"
              value={email}
              onChange={handleEmailChange}
              onBlur={handleBlur}
              className="email-form__input"
              placeholder=""
              disabled={pending}
              autoComplete="email"
            />
          </div>
          
          {errors.email && touched && (
            <span className="form-error">{errors.email}</span>
          )}
          {errors.common && (
            <span className="form-error">{errors.common}</span>
          )}

          <div className="pmc-notificationlist-form__buttons">
            <button 
              type="submit" 
              className="btn btn--save"
              disabled={pending}
            >
              {pending ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      ) : (
        <div className="success-message">
          <SuccessAnimation />
        </div>
      )}
    </div>
  );
};

export default React.memo(PmcNotificationListForm);